import axios from 'axios';
import {
  GET_TIERS,
  ADD_TIER,
  UPDATE_TIER,
  DELETE_TIER,
  TIERS_LOADING
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

export const getTiers = (programId) => (dispatch, getState) => {
  dispatch({ type: TIERS_LOADING });

  const url = programId ? `/api/tiers?program=${programId}` : '/api/tiers';
  axios
    .get(url, tokenConfig(getState))
    .then(res => dispatch({ type: GET_TIERS, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

export const addTier = (tierData) => (dispatch, getState) => {
  axios
    .post('/api/tiers', tierData, tokenConfig(getState))
    .then(res => dispatch({ type: ADD_TIER, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

export const updateTier = (id, tierData) => (dispatch, getState) => {
  axios
    .put(`/api/tiers/${id}`, tierData, tokenConfig(getState))
    .then(res => dispatch({ type: UPDATE_TIER, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

export const deleteTier = (id) => (dispatch, getState) => {
  axios
    .delete(`/api/tiers/${id}`, tokenConfig(getState))
    .then(() => dispatch({ type: DELETE_TIER, payload: id }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};
